import React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuIcon from '@mui/icons-material/Menu';
import { OpenerProps } from "../interfaces/OpenerProps"
import { Search } from './Search';

// idiomatic type alias
type Props = OpenerProps


export default function MenuBar(props: Props) {
    // constants
    const TITLE = "Index of Connectivity Subsetter"

    const { opener: setOpen, children } = props;

    // logic
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <IconButton
                        size="large"
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        sx={{ mr: 2 }}
                        onClick={handleDrawerOpen}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography
                        variant="h6"
                        noWrap
                        component="div"
                        sx={{ display: { xs: 'none', sm: 'block' } }}
                    >
                        {TITLE}
                    </Typography>
                    {/* TODO: search bar is too wide for phone displays */}
                    <div style={{ "flexGrow": 2 }}></div>
                    <Search />
                    <div style={{ "flexGrow": 4 }}></div>
                </Toolbar>
            </AppBar>
            {children}
        </Box>
    );
}
